import { Navigate, useLocation } from "react-router-dom";

export default function LegacyAiAgentRedirect({ to }) {
  const location = useLocation();

  return (
    <Navigate
      to={`${to}${location.search || ""}${location.hash || ""}`}
      replace
    />
  );
}
